import React, { useState } from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Sponsors from '../components/Sponsors';
import AdminLoginDialog from './AdminLoginDialog';

export default function Footer() {
    const [loginOpen, setLoginOpen] = useState(false);
    const navigate = useNavigate();

    const handleOpenLogin = (e) => {
        // no href on this element, but stop just in case
        e?.preventDefault?.();
        e?.stopPropagation?.();
        setLoginOpen(true);
    };

    const handleCloseLogin = () => setLoginOpen(false);

    const handleLoginSuccess = () => {
        setLoginOpen(false);
        navigate('/admin');
    };

    return (
        <Box component="footer" sx={{ mt: 6, textAlign: 'center', px: { xs: 2, md: 0 } }}>
            {/* Sponsors row */}
            <Box sx={{ mb: { xs: 3, md: 3 } }}>
                <Sponsors />
            </Box>

            <Container maxWidth="lg" sx={{ pb: { xs: 2, md: 2 } }}>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: { xs: '0.95rem', md: '0.875rem' } }}
                >
                    © {new Date().getFullYear()} Piedmont Historical Society. All rights reserved.
                </Typography>

                <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                    <Link href="/privacyPolicy" variant="body2" aria-label="Privacy Policy">
                        Privacy Policy
                    </Link>

                    {/* Admin button: no href to avoid any routing; looks like a link */}
                    <Link
                        component="button"
                        type="button"
                        onClick={handleOpenLogin}
                        variant="body2"
                        aria-label="Admin"
                        sx={{ cursor: 'pointer', textDecoration: 'underline', background: 'none', border: 0, p: 0 }}
                    >
                        Admin
                    </Link>
                </Stack>
            </Container>

            {/* Admin login popup */}
            <AdminLoginDialog
                open={loginOpen}
                onClose={handleCloseLogin}
                onSuccess={handleLoginSuccess}
            />
        </Box>
    );
}
